/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_History_TodayInputs */



/**
* | output |
* | --- |
* | "Today" |
*
* @param {Assistant_History_TodayInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_history_today = /** @type {((inputs?: Assistant_History_TodayInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_History_TodayInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aujourd'hui")
	if (locale === "de") return /** @type {LocalizedString} */ ("Heute")
	if (locale === "it") return /** @type {LocalizedString} */ ("Oggi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сегодня")
	if (locale === "es") return /** @type {LocalizedString} */ ("Hoy")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("今天")
	if (locale === "ja") return /** @type {LocalizedString} */ ("今日")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आज")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Hoje")
	return /** @type {LocalizedString} */ ("Today")
});